<template>
	<!-- ------------------------------------- 博客 ----------------------------------- -->
	<div class="blog" style="position: relative">
		<div id="mask" v-show="mask" @click="openmask()">
			<div class="scanText" style="text-align: center; width: 100%">
				扫描二维码分享
			</div>
			<div id="qrcode" ref="qrcode" v-show="mask == true"></div>
		</div>
		<!-- ---------------------------------- 顶部导航栏 ---------------------------------- -->
		<Header></Header>
		<!-- ---------------------------------- 海报图 ---------------------------------- -->
		<div class="banner">
			<div class="banner_text">
				<h6>了解更多</h6>
				<p>蔚诺快讯</p>
			</div>
		</div>
		<!-- ---------------------------------- 文章 ---------------------------------- -->
		<div class="article">
			<!-- 主文章 -->
			<!-- v-if="!((index + 1) % 2 == 0)" -->
			<div class="article_main">
				<!-- 移动端 -->
				<el-row :gutter="50" class="moble-div">
					<el-col v-for="(item, index) in blogsList" :key="index" :span="23"
						:class="(index + 1) % 2 == 0 ? 'jishu' : 'oushu'">
						<!-- 文章标题 -->
						<p class="article_title">{{ item.title }}</p>
						<!-- 文章信息 -->
						<div class="article_information" v-if="!((index + 1) % 2 == 0)">
							<!-- 日期时间 -->
							<p class="article_time">
								{{item.releaseTime.substr(0,10)}}
								<!-- {{
                                    `${
                                        item.pastTimes
                                            ? item.pastTimes + '前'
                                            : ''
                                    }`
                                }} -->
							</p>
							<!-- 第三方分享 -->
							<div class="article_share">
								<!-- <el-popover placement="top-start" trigger="hover">
                  <div>
                    <img
                      class="wechat_code"
                      src="../assets/images/icon/wechat-code.jpg"
                      alt=""
                    />
                  </div>
                  <img
                    src="../assets/images/icon/share1.png"
                    alt=""
                    slot="reference"
                  />
                </el-popover> -->
								<div style="display: flex">
									<img src="../assets/images/icon/share1.png" alt="" id="share-weixin"
										@click="share_click(item)" />
								</div>
								<img src="../assets/images/icon/share2.png" alt="" @click="weibo(item)" />
								<!-- <img
                  src="../assets/images/icon/share3.png"
                  alt=""
                  @click="xhs"
                /> -->
							</div>
						</div>
						{{item.img}}
						<!-- 文章图片 -->
						<img class="article_pic" :src="`${
                                'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
                                item.img
                            }`" alt="" />
						<!-- <em
              class="article_pic"
              :style="{
                backgroundImage: `url(${
                  'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
                  item.img
                })`,
              }"
            ></em> -->
						<!-- 文章标签 -->
						<p class="article_label" v-if="!((index + 1) % 2 == 0)">
							{{ `#${item.label}` }}
						</p>
						<!-- 文章简略 -->
						<div class="article_brief" v-html="$options.filters.ellipsis(item.backup1)"></div>
						<!-- 阅读更多 -->
						<span @click="toBlogDetails(item)">阅读更多 ></span>
						<!-- 虚线 -->
						<div class="article_line"></div>
					</el-col>
				</el-row>
				<!-- PC端 -->
				<el-row :gutter="50" class="pc-div">
					<el-col v-for="(item, index) in blogsList" :key="index" :span="23" v-if="!((index + 1) % 2 == 0)"
						:class="(index + 1) % 2 == 0 ? 'jishu' : 'oushu'">
						<!-- 文章标题 -->
						<p class="article_title">{{ item.title }}</p>
						<!-- 文章信息 -->
						<div class="article_information" v-if="!((index + 1) % 2 == 0)">
							<!-- 日期时间 -->
							<p class="article_time">
								{{item.releaseTime.substr(0,10)}}
								<!-- {{
                                    `${
                                        item.pastTimes
                                            ? item.pastTimes + '前'
                                            : ''
                                    }`
                                }} -->
							</p>
							<!-- 第三方分享 -->
							<div class="article_share">
								<!-- <el-popover placement="top-start" trigger="hover">
                  <div>
                    <img
                      class="wechat_code"
                      src="../assets/images/icon/wechat-code.jpg"
                      alt=""
                    />
                  </div>
                  <img
                    src="../assets/images/icon/share1.png"
                    alt=""
                    slot="reference"
                  />
                </el-popover> -->
								<div style="display: flex">
									<img src="../assets/images/icon/share1.png" alt="" id="share-weixin"
										@click="share_click(item)" />
								</div>
								<img src="../assets/images/icon/share2.png" alt="" @click="weibo(item)" />
								<!-- <img
                  src="../assets/images/icon/share3.png"
                  alt=""
                  @click="xhs"
                /> -->
							</div>
						</div>
						<!-- 文章图片 -->
						<img class="article_pic" :src="`${
                                'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
                                item.img
                            }`" alt="" />
						<!-- <em
              class="article_pic"
              :style="{
                backgroundImage: `url(${
                  'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
                  item.img
                })`,
              }"
            ></em> -->
						<!-- 文章标签 -->
						<p class="article_label" v-if="!((index + 1) % 2 == 0)">
							{{ `#${item.label}` }}
						</p>
						<!-- 文章简略 -->
						<div class="article_brief" v-if="!((index + 1) % 2 == 0) && item.backup1"
							v-html="$options.filters.ellipsis(item.backup1)"></div>
						<!-- 阅读更多 -->
						<span @click="toBlogDetails(item)">阅读更多 ></span>
						<!-- 虚线 -->
						<div class="article_line"></div>
					</el-col>
				</el-row>
			</div>
			<!-- 副文章 -->
			<el-row class="article_vice">
				<el-col>
					<!-- 订阅我们 -->
					<img class="subscribe" @click="tiaozhuan()" src="../assets/images/subsc.png" alt="" />
					<!-- 图标组 -->
					<div class="icon_group">
						<!-- facebook -->
						<a href="https://www.facebook.com/Renaud-Air-China-2139475802801534/" target="_blank">
							<img src="../assets/images/icon/facebook.png" alt="" />
						</a>
						<!-- <ins></ins> -->
						<a href="instagram.com/renaudairchina" target="_blank">
							<img src="../assets/images/icon/camera.png" alt="" />
						</a>
						<!-- 微信 -->
						<el-popover placement="top-start" trigger="hover">
							<div>
								<img class="wechat_code" src="../assets/images/icon/wechat-code.jpg" alt="" />
							</div>
							<img slot="reference" src="../assets/images/icon/wechat.png" alt="" />
						</el-popover>

						<a href="http://www.weibo.com/renaudair" target="_blank">
							<img src="../assets/images/icon/sina.png" alt="" />
						</a>

						<a href="https://www.xiaohongshu.com/user/profile/5ecf30ba0000000001003ddd?xhsshare=CopyLink&appuid=5ecf30ba0000000001003ddd&apptime=1626163317"
							target="_blank">
							<img src="../assets/images/icon/xhs.png" alt="" />
						</a>
					</div>
				</el-col>
				<el-col v-for="(item, index) in blogsList" :key="index" v-if="(index + 1) % 2 == 0">
					<!-- 虚线 -->
					<div class="article_line" style="margin: 30px 0"></div>
					<!-- 文章图片 -->
					<div class="vice_pic" v-if="item.img" :style="{
                            backgroundImage: `url(${
                                'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
                                item.img
                            })`,
                        }"></div>
					<!-- 标题 -->
					<p class="vice_title">{{ item.title }}</p>
					<!-- 日期时间 -->
					<p class="vice_time">
						{{ item.releaseTime.split(' ')[0] }}
					</p>
					<!-- 阅读更多 -->
					<span class="vice_more" @click="toBlogDetails(item)">阅读更多 ></span>
				</el-col>
			</el-row>
		</div>
		<!-- ---------------------------------- 分页栏 ---------------------------------- -->
		<div class="paging">
			<el-pagination background layout=" pager, next" :total="page.total" @current-change="currentChange($event)">
			</el-pagination>
		</div>
		<!-- ---------------------------------- 底部栏 ---------------------------------- -->
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '@/components/Header';
	import Footer from '@/components/Footer';
	import Axios from 'axios';
	import QRCode from 'qrcodejs2';
	export default {
		components: {
			Header,
			Footer,
		},
		data() {
			return {
				mask: false,
				mask1: false,
				blogsList: [],
				page: {
					pageNo: 1,
					pageSize: 10,
					total: 50,
				},
			};
		},
		filters: {
			//当渲染的文字超出30字后显示省略号
			ellipsis(value) {
				var reg = new RegExp('<[^>]+>', 'gi');
				if (value != null) {
					debugger
					let val = value.replace(reg, '');
					if (!val) return '';
					if (val.length > 60) {
						return val.slice(0, 60) + '...';
					}
					return val;
				}
			},
		},
		created() {
			this.getBlogsList();
		},
		methods: {
			share_click(value) {
				document.getElementById('qrcode').innerHTML = ''; //在调用qrCode前使用js原生方法清空元素内容
				let qrcode = new QRCode('qrcode', {
					width: 200, //图像宽度
					height: 200,
					colorDark: '#000000', //前景色
					colorLight: '#ffffff', //背景色
					typeNumber: 4,
					correctLevel: QRCode.CorrectLevel.H, //
				});
				var url = '118.89.87.102/blogDetails?id=' + value.id;
				qrcode.clear(); //清除二维码
				qrcode.makeCode(url); //生成另一个新的二维码
				// var mask = document.getElementById('mask')
				this.mask = !this.mask;
			},
			openmask() {
				this.mask = !this.mask;
			},

			// 跳转小红书
			// xhs() {
			//   window.open(
			//     "https://www.xiaohongshu.com/user/profile/5ecf30ba0000000001003ddd?xhsshare=CopyLink&appuid=5ecf30ba0000000001003ddd&apptime=1626163317",
			//     "_blank"
			//   );
			// },
			weibo(item) {
				window.open(
					'http://service.weibo.com/share/share.php?title=' +
					item.title +
					'&url=http://www.renaudchina.com/blog',
					'_blank'
				);
				// window.open("https://www.weibo.com/renaudair", "_blank");
			},
			/**订阅我们跳转**/
			tiaozhuan() {
				window.open('http://www.renaudchina.com/subscribe', '_blank');
				// this.$router.push({
				//   path: '/subscribe',
				// })
			},

			/** 切换分页 **/
			currentChange(index) {
				this.page.pageNo = index;
				this.getBlogsList();
			},
			/** 跳转文章详情 **/
			toBlogDetails(item) {
				this.$router.push({
					path: '/blogDetails',
					query: {
						id: item.id,
					},
				});
			},
			/** 获取列表 **/
			getBlogsList() {
				let page = JSON.parse(JSON.stringify(this.page));
				var url = `${this.api.ip}/jeecg-boot/h5/H5Controller2/blogsList`;
				Axios.get(url, {
					params: {
						pageNo: page.pageNo,
						pageSize: page.pageSize,
					},
				}).then((res) => {
					if (res.data.code === 200) {

						res.data.result.records.forEach((item) => {
							console.log(res.data.result.records)
							if (item.releaseTime) {
								let date = item.releaseTime
									.substring(0, 19)
									.replace(/-/g, '/');
								let time =
									new Date().getTime() - new Date(date).getTime();
								var days = parseInt(time / 1000 / 60 / 60 / 24, 10); //计算剩余的天数
								var hours = parseInt(
									(time / 1000 / 60 / 60) % 24,
									10
								); //计算剩余的小时

								this.$set(
									item,
									'pastTimes',
									`${days > 0 ? days + '天' : ''}${
                                    hours > 0 ? hours + '小时' : ''
                                }`
								);
							}
						});
						this.blogsList = res.data.result.records;
						let list = res.data.result.records;
						this.blogsList = list;
						this.page.pageNo = res.data.result.pages;
						this.page.pageSize = res.data.result.size;
						this.page.total = res.data.result.total;
					}
				});
			},
		},
	};
</script>

<style lang="less" scoped>
	img {
		max-width: 100% !important;
	}

	.wechat_code {
		width: 200px;
	}

	.oushu {
		// height: 1560px;
		// overflow: hidden;
		/*padding-left: 0 !important;*/
	}

	.article_main_gutter {
		position: relative;
	}

	.jishu {
		/*position: absolute;*/
		/*padding-right: 0 !important;*/
		/*right: 0;*/
	}

	// ---------------------------- 海报图 ---------------------------------
	.banner {
		width: 100%;
		height: 605px;
		background: url(../assets/images/blog-banner.png) no-repeat;
		background-size: 100% 100%;
		background-position: center;
		position: relative;

		.banner_text {
			width: 32%;
			position: absolute;
			bottom: 23%;
			right: 15%;
			font-family: '微软雅黑';
			color: #ffffff;

			h6 {
				font-size: 90px;
				letter-spacing: 15px;
				text-align: left;
				margin: 0 0 27px 0;
				font-weight: lighter;
				color: #ffffff;
			}

			p {
				font-size: 54px;
				letter-spacing: 10px;
				text-align: right;
				margin: 0;
			}
		}
	}

	// ---------------------------- 文章 ---------------------------------
	// ------------- mobile端样式 -------------
	@media only screen and (max-width: 960px) {
		.moble-div {
			display: block;
		}

		.pc-div {
			display: none;
		}

		// 屏幕小于960px
		.article {
			width: 93%;
			padding: 80px 0 60px 60px;
			box-sizing: border-box;

			// 主文章
			.article_main {

				// 文章标题
				.article_title {
					font-size: 70px;
				}

				// 文章信息
				.article_information {

					// 日期时间
					.article_time {
						font-size: 42px;
						margin-bottom: 30px;
					}

					// 第三方分享
					.article_share {
						img {
							width: 240px;
							height: 100px;
						}
					}
				}

				// 文章标签
				.article_label {
					font-size: 52px;
				}

				// 文章简略
				.article_brief {
					font-size: 52px !important;
					text-overflow: -o-ellipsis-lastline;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					line-clamp: 2;
					-webkit-box-orient: vertical;
					/*! autoprefixer: off */

					/deep/ span {
						font-size: 58px !important;
						line-height: 58px !important;
					}
				}

				// 阅读更多
				span {
					font-size: 52px;
				}
			}

			// 副文章
			.article_vice {
				display: none;
			}
		}
	}

	// ------------- pc端样式 -------------
	@media only screen and (min-width: 960px) {

		// 屏幕大于960px
		.article {
			width: 65%;
			padding: 80px 0 60px 0;

			// 主文章
			.article_main {
				width: 80% !important;

				// 文章标题
				.article_title {
					font-size: 40px;
				}

				// 文章信息
				.article_information {
					display: flex;
					align-items: center;
					justify-content: space-between;

					// 日期时间
					.article_time {
						font-size: 22px;
						margin: 0;
					}

					// 第三方分享
					.article_share {}
				}

				// 文章标签
				.article_label {
					font-size: 22px;
				}

				// 文章简略
				.article_brief {
					font-size: 22px;
					text-overflow: -o-ellipsis-lastline;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 4;
					line-clamp: 4;
					-webkit-box-orient: vertical;
					/*! autoprefixer: off */
				}

				// 阅读更多
				span {
					font-size: 22px;
				}
			}

			// 副文章
			.article_vice {
				display: block;
			}
		}
	}

	.article {
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		font-family: '微软雅黑';

		// 主文章
		.article_main {
			width: 100%;

			// 文章标题
			.article_title {
				color: #164194;
				letter-spacing: 2px;
				margin: 0;
				cursor: pointer;
			}

			// 文章信息
			.article_information {
				font-size: 20px;
				width: 100%;
				margin: 10px 0 30px 0;

				// 日期时间
				.article_time {
					color: #164194;
					letter-spacing: 1px;
				}

				// 第三方分享
				.article_share {
					display: flex;

					img {
						margin: 0 2px;
						cursor: pointer;
					}
				}
			}

			// 文章图片
			.article_pic {
				display: inline-block;
				width: 100%;
				background-position: center;
				background-repeat: no-repeat;
				background-size: 100% 100%;
			}

			// 文章标签
			.article_label {
				margin: 20px 0 20px 0;
				color: #49b8e8;
				letter-spacing: 2px;
			}

			// 文章简略
			.article_brief {
				width: 100%;
				color: #164194;
				line-height: 1.8;
				letter-spacing: 1px;
				margin-bottom: 50px;
				box-sizing: border-box;
				overflow: hidden;
			}

			// 阅读更多
			span {
				color: #49b8e8;
				letter-spacing: 2px;
				cursor: pointer;
			}

			// section{
			// 	font-size: 20px;
			// 	span{
			// 		font-size: 40px;
			// 	}
			// }
		}

		// 副文章
		.article_vice {
			width: 30%;

			// 订阅我们
			.subscribe {
				width: 100%;
				cursor: pointer;
				display: block;
			}

			// 图标组
			.icon_group {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin: 22px 0;

				img {
					width: 52px;
					height: 52px;
				}
			}

			// 插图
			.vice_pic {
				width: 100%;
				display: inline-block;
				height: 120px;
				background-position: center;
				background-repeat: no-repeat;
				background-size: contain;
			}

			// 标题
			.vice_title {
				font-size: 28px;
				color: #164194;
				letter-spacing: 2px;
				margin: 25px 0 10px 0;
			}

			// 日期时间
			.vice_time {
				font-size: 22px;
				color: #164194;
				letter-spacing: 1px;
				margin: 15px 0;
			}

			// 阅读更多
			.vice_more {
				font-size: 22px;
				color: #49b8e8;
				letter-spacing: 2px;
				cursor: pointer;
			}
		}
	}

	// 虚线
	.article_line {
		width: 100%;
		border-bottom: 3px dashed #164194;
		margin: 40px 0 20px 0;
	}

	// ---------------------------- 分页栏 ---------------------------------
	@media only screen and (max-width: 960px) {

		// 屏幕小于960px
		.paging {
			width: 90%;
		}

		.paging /deep/ .el-pager li {
			width: 81px;
			height: 81px;
			font-size: 46px;
			line-height: 81px;
		}

		.paging /deep/ .el-pagination .btn-next {
			width: 81px;
			height: 81px;
		}

		.paging /deep/ .el-pagination .btn-prev {
			width: 81px;
			height: 81px;
		}

		.paging /deep/ .el-pagination .btn-next .el-icon {
			font-size: 48px;
		}

		.paging /deep/ .el-pagination .btn-prev .el-icon {
			font-size: 48px;
		}
	}

	// ------------- pc端样式 -------------
	@media only screen and (min-width: 960px) {
		.moble-div {
			display: none;
		}

		.pc-div {
			display: block;
		}

		// 屏幕大于960px
		.paging {
			width: 65%;
		}

		.paging /deep/ .el-pager li {
			width: 51px;
			height: 51px;
			font-size: 26px;
			line-height: 51px;
		}

		.paging /deep/ .el-pagination .btn-next {
			width: 51px;
			height: 51px;
		}

		.paging /deep/ .el-pagination .btn-prev {
			width: 51px;
			height: 51px;
		}

		.paging /deep/ .el-pagination .btn-next .el-icon {
			font-size: 28px;
		}

		.paging /deep/ .el-pagination .btn-prev .el-icon {
			font-size: 28px;
		}
	}

	.paging {
		margin: 0 auto;
		margin-bottom: 100px;
	}

	.paging /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #575756;
	}

	.paging /deep/ .el-pager li {
		border: 1px solid #575756;
		font-weight: lighter;
	}

	.paging /deep/ .el-pagination .btn-next {
		background-color: #fff;
	}

	.paging /deep/ .el-pagination .btn-prev {
		background-color: #fff;
	}

	@media screen and (max-height: 3050px) {
		#qrcode {
			// position: absolute;
			// top: 26%;
			// left: 32%;
			/* right: 0; */
			width: 100%;
			display: flex;
			justify-content: center;
			padding-top: 10px;
		}

		#qrcode img {
			width: 200px; //图像宽度
			height: 200px; //图像高度
			// position: absolute;
			// top: 32px;
		}

		#mask {
			position: fixed;
			opacity: 0.9;
			//  filter:alpha(opacity=50);
			left: 50%;
			top: 50%;
			padding: 40px;
			transform: translate(-50%, -50%);
			background: #fff;
			z-index: 13;
			border-radius: 15px;
			//  display: none;
		}

		.scanText {
			font-size: 20px;
		}
	}

	// @media screen and (max-height: 920px) {
	//    #qrcode{
	//    position: absolute;
	//     top: 26%;
	//     left: 28%;
	//     /* right: 0; */
	//     z-index: 14;
	//   }

	//   #qrcode img{
	//       width:220px;//图像宽度
	//      height: 220px; //图像高度
	//      position: absolute;
	//      top: 32px;
	//   }

	//   #mask {
	//   position: fixed;
	//   opacity: 0.9;
	//   left: 50%;
	//   top: 50%;
	//   transform: translate(-50%,-50%);
	//   //  filter:alpha(opacity=50);
	//   // bottom: 0;
	//   // left: 32%;
	//   // right: 0;
	//   // top: 30%;
	//   width:10rem;
	//   height: 8rem;
	//   background: #fff;
	//   z-index: 13;
	//   border-radius: 15px;
	//   //  display: none;
	// }
	// }
</style>



// WEBPACK FOOTER //
// src/view/blog.vue